export const MODAL_CLASS = "old-modal";
export const OVERLAY_CLASS = `${MODAL_CLASS}__overlay`;
